// OLAPLEX PDP (PDP-ANALYSIS-2026-07-30)
// 1) Dots circulares de la galería mobile: sincronizados con el scroll-snap del
//    slider de Dawn y clickeables (la ref pagina con bullets, sin flechas).
// 3) Riel de thumbnails desktop (ref): muestra ~5 y una flecha debajo para
//    avanzar; al llegar al final la flecha apunta hacia arriba.
// 2) Orden mobile del hero: título / estrellas / precio se mueven ARRIBA de la
//    galería en <990px (como olaplex.com). Se mueven los nodos reales (no se
//    clonan) para que los updates por variante de product-info.js sigan
//    apuntando al mismo elemento.

(function () {
  function initDots() {
    document.querySelectorAll('[data-olx-dots]').forEach(function (dots) {
      if (dots.dataset.olxInit) return;
      dots.dataset.olxInit = '1';
      var sliderComponent = dots.closest('slider-component');
      var slider = sliderComponent && sliderComponent.querySelector('ul.slider');
      if (!slider) return;
      var dotEls = Array.prototype.slice.call(dots.querySelectorAll('.olx-gallery-dots__dot'));
      var slides = function () {
        return Array.prototype.slice
          .call(slider.querySelectorAll('.slider__slide'))
          .filter(function (s) { return s.clientWidth > 0; });
      };
      dots.addEventListener('click', function (e) {
        var b = e.target.closest('.olx-gallery-dots__dot');
        if (!b) return;
        var s = slides()[Number(b.dataset.index)];
        if (s) slider.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
      });
      var ticking = false;
      slider.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var list = slides();
          if (!list.length) return;
          var w = list[0].clientWidth || 1;
          var idx = Math.min(list.length - 1, Math.round(slider.scrollLeft / w));
          dotEls.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        });
      });
    });
  }

  var MOBILE_MQ = window.matchMedia('(max-width: 989px)');
  // .product__tax viaja con el precio: tiene margin-top negativo en Dawn para
  // pegarse a él — huérfano en la columna se monta sobre la galería.
  var HERO_SELECTORS = ['.product__title', '.olx-pdp__reviews', '[id^="price-"]', '.product__tax'];

  function initMobileOrder() {
    document.querySelectorAll('product-info').forEach(function (info) {
      var grid = info.querySelector('.product.grid');
      var media = info.querySelector('.product__media-wrapper');
      if (!grid || !media) return;
      var head = info.querySelector('.olx-mobile-head');
      if (!head) {
        head = document.createElement('div');
        head.className = 'olx-mobile-head';
        grid.insertBefore(head, media);
      }
      var container = info.querySelector('.product__info-container');
      if (!container) return;
      HERO_SELECTORS.forEach(function (sel) {
        var node = container.querySelector(sel) || head.querySelector(sel);
        if (!node) return;
        if (MOBILE_MQ.matches) {
          if (node.parentNode !== head) {
            // marcador para devolverlo a su lugar exacto en desktop
            if (!node.olxSlot) {
              node.olxSlot = document.createElement('span');
              node.olxSlot.hidden = true;
              node.parentNode.insertBefore(node.olxSlot, node);
            }
            head.appendChild(node);
          }
        } else if (node.olxSlot && node.parentNode === head) {
          node.olxSlot.parentNode.insertBefore(node, node.olxSlot.nextSibling);
        }
      });
    });
  }

  function initRailArrow() {
    document.querySelectorAll('.product--thumbnail [id^="GalleryThumbnails"]').forEach(function (rail) {
      if (rail.dataset.olxRail) return;
      rail.dataset.olxRail = '1';
      var list = rail.querySelector('ul.thumbnail-list');
      if (!list) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'olx-rail-arrow';
      btn.setAttribute('aria-label', 'Más imágenes');
      btn.innerHTML = '<svg viewBox="0 0 10 6" width="10" height="6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
      rail.appendChild(btn);
      var update = function () {
        var overflow = list.scrollHeight - list.clientHeight > 4;
        btn.hidden = !overflow;
        btn.classList.toggle('is-up', overflow && list.scrollTop + list.clientHeight >= list.scrollHeight - 4);
      };
      btn.addEventListener('click', function () {
        var step = list.clientHeight * 0.8;
        list.scrollBy({ top: btn.classList.contains('is-up') ? -list.scrollHeight : step, behavior: 'smooth' });
      });
      list.addEventListener('scroll', update);
      window.addEventListener('resize', update);
      update();
    });
  }

  function initAll() {
    initDots();
    initMobileOrder();
    initRailArrow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  MOBILE_MQ.addEventListener('change', initMobileOrder);
  // product-info re-renderiza partes de la sección al cambiar variante o en el
  // theme editor; re-chequear sin duplicar (los init son idempotentes).
  document.addEventListener('shopify:section:load', initAll);
})();
